export default "__VITE_ASSET__D9KUR8vI__"